<template>
    <el-popover
        placement="bottom-end"
        width="250"
        trigger="click">
        <div class="popover-box">
            <div class="popover-box-search">
                <el-input v-model="keyword" placeholder="请输入查询关键字"/>
            </div>
            <div class="popover-box-list">
                <el-collapse v-model="activeCollapseNames" >
                    <el-collapse-item 
                        v-for="item in mapList"
                        :key="item.name"
                        :title="item.display_name" :name="item.name"
                    >
                        <div 
                            v-for="child in item.children"
                            :key="child.name"
                            class="child-item"
                            @click="()=>$emit('item-click', child)"
                        >
                            {{child.display_name}}
                            <template v-if="child.config.title">
                                <el-tooltip
                                    effect="dark"
                                    :content="child.config.title"
                                    placement="top"
                                >
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </template>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <div v-if="!mapList.length" class="no-data tac mt10 mb10">暂无数据</div>
            </div>
        </div>
        <span slot="reference"><slot/></span>
    </el-popover>
</template>

<script>
export default {
    name: 'PopoverSelectData',
    props: [ 'list', 'checkList' ],
    data() {
        return {
            activeCollapseNames: [],
            keyword: ''
        }
    },
    computed: {
        checkIds() {
            return this.checkList.map(v=>v.name);
        },
        mapList() {
            return this.list.map(v=> {
                return {
                    ...v,
                    children: v.children.filter(
                        v=>!this.checkIds.includes(v.name) && 
                        (v.display_name || "").toLocaleLowerCase()
                        .indexOf(this.keyword.toLocaleLowerCase()) > -1
                    )
                }
            }).filter(v=> !!v.children.length)
        }
    },
    watch: {
        list: {
            handler(n) {
                this.activeCollapseNames = n.map(v=>v.name)
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.popover-box {
    max-height: 300px;
    display: flex;
    flex-direction: column;
    &-list {
        flex: 1;
        overflow: auto;
        .child-item {
            padding-left: 14px;
            cursor: pointer;
            &:hover {
                background: #e8eaec;
            }
        }
    }
    &::v-deep .el-tabs__header {
        margin: 0;
    }

    &::v-deep .el-collapse-item__header {
        height: 32px;
        line-height: 32px;
        font-weight: bold;
        font-size: 12px;
    }

    &::v-deep .el-collapse-item .el-collapse-item__content {
        padding-bottom: 10px;
    }

}

</style>